<template>

  <label class="switch">
    <input type="checkbox" class="switch-input" @change.stop="updateValue">
    <span class="label" v-bind:class="{ active: !optionTwo}">{{labelOne}}</span>
    <div class="switch-icon"><img src="../assets/images/switch-icon.svg" v-bind:class="{ right: optionTwo }"></div>
    <span class="label" v-bind:class="{ active: optionTwo}">{{labelTwo}}</span>
  </label>
</template>

<script>

export default {
  name: 'input-switch',
  props: ['model', 'nameOne', 'nameTwo', 'labelOne', 'labelTwo', 'valueOne', 'valueTwo'],
  data() {
    return {
      optionTwo: false
    }
  },
  methods: {
    updateValue(e) {
      this.optionTwo = !this.optionTwo
      if (this.optionTwo) {
        this.$emit('update-value', this.model, this.valueTwo)
      }
      else {
        this.$emit('update-value', this.model, this.valueOne)
      }

    }

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.switch input {
  display: none;
}

.switch .switch-icon {
  display: inline-block;
  cursor: pointer;
  width: 88px;
  height: 25px;
  background: url('../assets/images/switch-track.svg');
  margin: 0 20px;
  position: relative;
  top: 20px;
}
.switch .switch-icon img {
  position: relative;

}
.switch .switch-icon img {
  top: -6px;
  left: -10px;
  transition: left 0.25s ease-in-out;
}

.switch .switch-icon img.right {
  left: 40px;
  transition: left 0.25s ease-in-out;
}

.switch .label {
  color: #81A0AA;
  transition: color 0.25s ease-in-out;
}

.switch .label.active {
  color: #51C6FE;
  transition: color 0.25s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// InputSwitch.vue?27eeb84b